import { create } from "zustand";

const useScrollspyStore = create((set) => ({
  items: [],
  scrollspySetItems: (items) => set({ items }),
}));

export default useScrollspyStore;
